import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from '../inc/header';
import Footer from '../inc/footer';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Modal, Button } from "react-bootstrap";
import { Link } from 'react-router-dom';
import 'animate.css';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import OwlCarousel from 'react-owl-carousel';
import { color, motion } from "framer-motion";
import ReCAPTCHA from "react-google-recaptcha";
import CountUp from "react-countup";
import { NavLink } from 'react-router-dom';
function Index() {

    // https://crmradius.gemsdrive.co.uk/api/get_projects
    const [activeId, setActiveId] = useState(null);
    const [radiusprojects, setRadiusprojects] = useState([]);
    const [carouselKey, setCarouselKey] = useState(0);


    useEffect(() => {
        const fetchWebsiteProjects = async () => {
            try {
                const response = await fetch(
                    "https://crmradius.gemsdrive.co.uk/public/api/get_projects_for_home"
                );
                if (!response.ok) throw new Error("API error");
                const result = await response.json();
                setRadiusprojects((result.category || []));
                // setRadiusprojects((result.category || []).slice(0, 8)); // Limit to 8 projects
            } catch (error) {
                console.error(error);
            }
        };

        fetchWebsiteProjects();
    }, []);
    console.log("Projects Data:", radiusprojects);

    useEffect(() => {
        if (radiusprojects.length) {
            setCarouselKey(prev => prev + 1);
        }
    }, [radiusprojects]);

    useEffect(() => {
        if (radiusprojects.length) {
            setTimeout(() => {
                if (window.$ && window.$(".owl-carousel").length) {
                    window.$(".owl-carousel").trigger("refresh.owl.carousel");
                }
            }, 300);
        }
    }, [radiusprojects]);

    const refreshOwl = () => {
        setTimeout(() => {
            if (window.$ && window.$(".owl-carousel").length) {
                window.$(".owl-carousel").trigger("refresh.owl.carousel");
            }
        }, 300);
    };
    const [activeIndexModal, setActiveIndexModal] = useState(-1);
    const openProject = (project, index) => {
        const imagesArray = project.multiple_images
            ? project.multiple_images.split(",")
            : [];

        setActiveProject({
            id: project.id, // ✅ keep ID
            title: project.project_name,
            img: `https://crmradius.gemsdrive.co.uk/main_image/${project.main_img}`,
            multiple_img: imagesArray.map(
                img => `https://crmradius.gemsdrive.co.uk/main_image/${img}`
            ),
            short_description: project.short_description ?? "",
            description: project.description ?? "",
            details: project.short_description ?? "",
            client: project.client ?? "N/A",
            date: project.date ?? "N/A",
            skills: project.skills ? project.skills.split(",") : [],
            projectUrl: project.project_url ?? "#",
        });

        setActiveIndexModal(index);   // ✅ STORE INDEX
        setShowModal(true);
    };


    const goToPrevious = () => {
        if (activeIndexModal > 0) {
            openProject(radiusprojects[activeIndexModal - 1], activeIndexModal - 1);
        }
    };

    const goToNext = () => {
        if (activeIndexModal < radiusprojects.length - 1) {
            openProject(radiusprojects[activeIndexModal + 1], activeIndexModal + 1);
        }
    };

    
    // Background colors for each accordion

    const sectionColors = {
        One: "rgba(228, 0, 116, 1)", // yellow
        Two: "rgba(129, 203, 212, 1)", // red
        Three: "rgba(30, 25, 66, 1)", // blue
        Four: "rgba(3, 3, 3, 1)", // pink
        Five: "rgba(228,0,116,1)", // pink
    };


    const sectionImages = {
        One: "/assets/img/slides/Main-Slider-1.png",
        Two: "/assets/img/slides/Main-Slider-2.jpg",
        Three: "/assets/img/slides/Main-Slider-3.jpg",
        Four: "/assets/img/slides/Main-Slider-4.jpg",
        Five: "/assets/img/slides/Main-Slider-5.jpg",
    };

    // Default background
    const defaultImage = "/assets/img/slides/Main-Slider-1.png";
    const defaultColor = "rgba(228, 0, 116, 1)";

    const handleToggle = (id) => {
        setActiveId(activeId === id ? null : id);
    };

    const fadeInDown = {
        hidden: { opacity: 0, y: -50 },
        visible: { opacity: 1, y: 0 },
    };

    const fadeInUp = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0 },
    };

    const blurIn = {
        hidden: { opacity: 0, filter: "blur(10px)" },
        visible: { opacity: 1, filter: "blur(0px)" },
    };


    const [activeIndex, setActiveIndex] = useState(null);


    const reasons = [
        {
            title: "INFRASTRUCTURE",
            content: `With a strong army of 60 Skilled Crew Members, we form a high spirited and enthusiastic team to work with. We turn a big project to look like a simple one. Encompass over 16,000 feet in a strategically placed warehouse location in Al Quoz Industrial Area 02, logistics to serve all emirates has been a boon.`,
        },
        {
            title: "ONE STOP SHOP",
            content: `The traditional concept of One Stop Shop defines us, with latest machinery in all our fabricating departments, we keep the clients glued to us forever. Wood and Metal fabrication – CNC Router, Planner, Circular Saws, Laser Machine, Angle Cutter, Welding, Grinding, Paint Booth. Acrylic Fabrication – (Signage) – Letter / Channelium Bending, Laser Cutting, Circular Saw. Printing – HP Latex 370 & 375.`,
        },
        {
            title: "ROBUST CLIENT MANAGEMENT",
            content: `With the world pacing, we run at the same or higher speed when it comes to Customer Relationship Management. Round the clock service is our company principle and habit that each Radius member adheres for any and every job requirement.`,
        },
        {
            title: "PRO-ACTIVE APPROACH",
            content: `Creating a Win-Win situation with better understanding of Client Requisite, Location condition, Current Weather Conditions and Other such Parameters presenting a more feasible and practical production and execution plan.`,
        },
    ];

    const toggleCollapse = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };
   
    const [showModal, setShowModal] = useState(false);
    const [activeProject, setActiveProject] = useState(null);
    const carouselOptions = {
        items: 4,
        margin: 20,
        loop: true,
        autoplay: true,
        autoplayTimeout: 3000,
        dots: true,
        nav: false,
        responsive: {
            0: { items: 1 },
            768: { items: 2 },
            992: { items: 3 },
            992: { items: 4 },
        },
    };
 

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });

    const [captchaToken, setCaptchaToken] = useState(null);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleCaptchaChange = (token) => {
        setCaptchaToken(token);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!captchaToken) {
            alert("Please verify the reCAPTCHA!");
            return;
        }

        // Example: send form + token to backend
        const payload = { ...formData, captchaToken };

        // fetch("https://your-backend-api/contact", {
        //     method: "POST",
        //     headers: { "Content-Type": "application/json" },
        //     body: JSON.stringify(payload),
        // })
        //     .then((res) => res.json())
        //     .then((data) => {
        //         alert("Form submitted successfully!");
        //         setCaptchaToken(null);
        //     })
        //     .catch(() => alert("Error submitting form!"));
    };
    useEffect(() => {
        const setVH = () => {
            document.documentElement.style.setProperty(
                "--vh",
                `${window.innerHeight * 0.01}px`
            );
        };
        setVH();
        window.addEventListener("resize", setVH);
        return () => window.removeEventListener("resize", setVH);
    }, []);
    

    const sliderOptions = {
        items: 1,
        loop: true,
        nav: true,
        dots: true,
        autoplay: true,
        autoplayTimeout: 700000,
        navText: ["", ""],
    };

    return (
        <>
        <style type="text/css">
        {`  
           /* Desktop */
            .slider-item {
            position: relative;
            height: 700px;
            overflow: hidden;
            }

            /* Image behavior */
            .slider-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            }

            /* Text above image */
            .slider-item .container {
                position: relative;
                z-index: 2;
            }

            .hero-title {
                color: #fff !important;
                font-weight: 700;
                text-shadow: 0 3px 10px rgba(0,0,0,0.8);
            }

            .hero-sub {
                color: #fff !important;
                text-shadow: 0 2px 6px rgba(0,0,0,0.7);
                font-weight: 700;
                font-size: 1.25rem;
            }

            /* Tablet */
            @media (max-width: 991px) {
            .slider-item {
                height: 550px;
            }

            .slider-img {
                object-position: center top;
            }
            }

            /* Mobile */
            @media (max-width: 575px) {
                .slider-item {
                    height: 420px;
                }

                .slider-img {
                    object-position: center top;
                }

                .hero-title {
                    color: #fff;
                    font-weight:500 !important;
                    font-size: 1.5rem !important;
                    text-shadow: 0 3px 10px rgba(0,0,0,0.8) !important;
                }

                .hero-sub {
                    color: #fff;
                    text-shadow: 0 2px 6px rgba(0,0,0,0.7) !important;
                    font-weight: 600 !important;
                    font-size: 1.0rem !important;
            }


                



        `}
        </style>
        <div>
            <Helmet>
                <title>Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company - Home</title>
                <meta name="description" content="Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company" />
                <meta property="og:title" content="Radius - Home" />
                <meta property="og:description" content="Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company" />
            </Helmet>

            <div className="body bg-grey">
                <Header />
                <div role="main" className="main">
                    <section id="home">
                        <OwlCarousel
                            className="owl-theme   manual dots-inside dots-horizontal-center show-dots-hover nav-inside nav-inside-plus nav-dark nav-md nav-font-size-md show-nav-hover mb-0"
                            {...sliderOptions}
                            style={{ height: "100vh" }}
                        >

                            {[
                                "Main-Slider-1.png",
                                "Main-Slider-2.jpg",
                                "Main-Slider-3.jpg",
                                "Main-Slider-4.jpg",
                                "Main-Slider-5.jpg",
                                "Main-Slider-6.jpg"
                            ].map((img, index) => (
                            <div
                                className="position-relative pt-5 d-flex align-items-center"
                                style={{
                                    backgroundImage: `url(/assets/img/slides/${img})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    height: "100vh",
                                    // backgroundColor: "#35383d",
                                }}
                            >
                                <div className="container position-relative z-index-3 h-100">
                                    <div className="row justify-content-center align-items-center h-100">
                                        <div className="col-lg-6">
                                            <div className="d-flex flex-column align-items-center text-center">
                                                {/* <h3
                                                    className="position-relative text-color-light text-4 font-weight-medium px-4 mb-3 appear-animation"
                                                    data-appear-animation="fadeInDownShorterPlus"
                                                >
                                                    WE WORK HARD AND PORTO HAS
                                                </h3>

                                                <h2
                                                    className="text-color-light font-weight-extra-bold text-12 mb-4 appear-animation"
                                                    data-appear-animation="blurIn"
                                                    data-appear-animation-delay="500"
                                                >
                                                    THE <span className="position-relative">BEST</span> DESIGN
                                                </h2>

                                                <p
                                                    className="text-4 text-color-light font-weight-light opacity-7 mb-4"
                                                    data-plugin-animated-letters
                                                >
                                                    Trusted by over <strong>40,000</strong> satisfied users
                                                </p>

                                                <a
                                                    href="#"
                                                    className="btn btn-primary btn-rounded font-weight-bold text-3 px-5 py-3 appear-animation"
                                                    data-appear-animation="fadeInUpShorter"
                                                    data-appear-animation-delay="1600"
                                                >
                                                    GET STARTED NOW!
                                                </a> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            ))}
                              

                        </OwlCarousel>
                    </section>

                    <section
                        className="section bg-color-grey border-0 m-0"
                        id="EngineeredSection"
                        style={{
                            minHeight: "",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            paddingBottom: "100px",
                            transition: "background-color 0.6s ease-in-out",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <div className="container container-xl-custom h-75 d-flex align-items-center justify-content-center text-center">
                            <div className="row w-100 justify-content-between align-items-center flex-column flex-md-row text-start">
                                <div className="col-lg-5 text-center text-md-start mt-3 mb-4 mb-md-0">
                                    <motion.h1
                                        className="fw-bold text-dark mb-3"
                                        initial={{ opacity: 0, x: 50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 0.6 }}
                                        style={{ fontSize: '38px' }}
                                    >
                                        About <span className='text-pink'>Radius</span>
                                    </motion.h1>
                                </div>
                                <div className="col-lg-7">
                                    <motion.p
                                        className="text-muted"
                                        initial={{ opacity: 0, y: 30 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        transition={{ delay: 0.2, duration: 0.6 }}>
                                        Radius is Interior Fit Out Company in Dubai which established in 2007 and built on a legacy of uncompromising craftsmanship and world-class project management, Our divisions; Event Production, Exhibition Stand Fabrication, Interior Fit-outs, Signage, Large Format Printing & Branding are led by passionate experts in their field, With a focus on finding creative solutions on every aspect of your events, from strategic planning to finding venues and creating immersive experiences.
                                    </motion.p>
                                    <motion.p
                                        className="text-muted"
                                        initial={{ opacity: 0, y: 60 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        transition={{ delay: 0.2, duration: 0.6 }}>
                                        We organize memorable events in various sectors including healthcare, technology, finance, energy, engineering… “Original concepts and impeccable execution” is what RADIUS promise. Whatever you are looking for, no matter what your event production works, exhibition, interior fit-outs, printing or signage needs are, we will be able to provide creative solutions.
                                    </motion.p>

                                </div>
                            </div>
                        </div>
                    </section>



                    <section
                        className="section section-parallax section-parallax-2 border-0 m-0  position-relative" id="services"
                        style={{
                            borderTopLeftRadius: "0px",
                            borderBottomRightRadius: "0px",
                            minHeight: "",
                            backgroundImage: `url('${activeId ? sectionImages[activeId] : defaultImage}')`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            paddingTop: "100px",
                            paddingBottom: "100px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {/* Transparent Overlay */}
                        <div
                            style={{
                                position: "absolute",
                                inset: 0,
                                backgroundColor: activeId
                                    ? sectionColors[activeId].replace("1)", "0.65)")
                                    : "rgba(228, 0, 116, 0.65)",
                                borderTopLeftRadius: "0px",
                                borderBottomRightRadius: "0px",
                                transition: "background-color 0.6s ease-in-out",
                                zIndex: 1,
                            }}
                        ></div>

                        {/* Content */}
                        <div
                            className="container position-relative"
                            style={{
                                zIndex: 2,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <div className="row justify-content-start w-100">
                                <div className="col-lg-7">
                                    <h2
                                        className="text-white fw-bold mb-5"
                                        style={{ fontSize: "3rem", textAlign: "left" }}
                                    >
                                        Services
                                    </h2>

                                    <div
                                        className="accordion accordion-modern-status accordion-modern-status-arrow accordion-modern-status-arrow-dark"
                                        id="accordion2000"
                                    >
                                        {[
                                            {
                                                id: "One",
                                                title: "Interiors",
                                                items: [
                                                    "Turnkey Projects",
                                                    "Stand Alone and Mall Stores",
                                                    "F&B Outlets – Hot/ Cold Kitchen",
                                                    "Shell and Core Projects",
                                                    "Commercial Office Interiors",
                                                    "Refurbishments",
                                                    "Authority Approvals",
                                                ],
                                                img: "/assets/img/slides/Main-Slider-1.jpg",
                                                slug: "process-services",
                                            },
                                            {
                                                id: "Two",
                                                title: "Event",
                                                items: [
                                                    "Staging",
                                                    "Backdrop",
                                                    "Indoor and Outdoor Arch",
                                                    "LED Screen Cladding",
                                                    "Gallery Walls",
                                                    "Photo Ops",
                                                    "Trophies and Signage",
                                                ],
                                                img: "/assets/img/slides/Main-Slider-2.jpg",
                                                slug: "process-services",
                                            },
                                            {
                                                id: "Three",
                                                title: "Exhibition",
                                                items: [
                                                    "Stand Designing",
                                                    "Conceptualization",
                                                    "Pavilions",
                                                    "Mezzanine Stands",
                                                    "Stands with Hanging Canopy",
                                                    "Island Stands",
                                                    "Shell Schemes",
                                                ],
                                                img: "/assets/img/slides/Main-Slider-3.jpg",
                                                slug: "process-services",
                                            },
                                            {
                                                id: "Four",
                                                title: "Printing",
                                                items: [
                                                    "Front/Back Lit Banner and Fabric",
                                                    "Mesh Banner & 550gsm Durable Banners",
                                                    "Outdoor Vinyl with UV Lamination",
                                                    "One Way Vision",
                                                    "Day & Night Vinyl (Dual Artwork)",
                                                    "Indoor Vinyl with Lamination",
                                                    "Duratrans and Light Passing Vinyl",
                                                ],
                                                img: "/assets/img/slides/Main-Slider-4.jpg",
                                                slug: "process-services",
                                            },
                                            {
                                                id: "Five",
                                                title: "Signage",
                                                items: [
                                                    "Indoor Signage",
                                                    "Outdoor Signage",
                                                    "Warehouse/Building Signage",
                                                    "Roof Top Signage",
                                                    "Hoardings and Billboards",
                                                    "Way Finding Signs",
                                                    "Traffic Signs",
                                                ],
                                                img: "/assets/img/slides/Main-Slider-5.jpg",
                                                slug: "process-services",
                                            },
                                        ].map((service) => (
                                            <div
                                                key={service.id}
                                                className="card card-default box-shadow-8 mb-3 border-0 bg-transparent"
                                            >
                                                <div
                                                    className="card-header d-flex justify-content-between align-items-center"
                                                    id={`heading${service.id}`}
                                                    style={{
                                                        cursor: "pointer",
                                                        borderBottom: "2px solid rgba(255,255,255,0.3)",
                                                    }}
                                                    onClick={() => handleToggle(service.id)}
                                                >
                                                    <h4
                                                        className="card-title m-0 text-white fw-bold"
                                                        style={{ fontSize: "1.875rem", textAlign: "left" }}
                                                    >
                                                        {service.title}
                                                    </h4>
                                                    <i
                                                        className={`fas fa-chevron-down text-white transition-all`}
                                                        style={{
                                                            transform:
                                                                activeId === service.id ? "rotate(180deg)" : "rotate(0deg)",
                                                            transition: "transform 0.3s ease",
                                                            fontSize: "1.25rem",
                                                        }}
                                                    ></i>
                                                </div>

                                                <div
                                                    id={`collapse${service.id}`}
                                                    className={`collapse ${activeId === service.id ? "show" : ""}`}
                                                    aria-labelledby={`heading${service.id}`}
                                                    data-bs-parent="#accordion2000"
                                                >
                                                    <div className="card-body pt-4 text-white">
                                                        <ul
                                                            style={{
                                                                color: "white",
                                                                lineHeight: "1.8",
                                                                fontSize: "17px",
                                                                textAlign: "left",
                                                                paddingLeft: "20px",
                                                            }}
                                                        >
                                                            {service.items.map((item, index) => (
                                                                <li key={index}>{item}</li>
                                                            ))}
                                                        </ul>

                                                        <div style={{ textAlign: "left" }}>
                                                            <NavLink
                                                                to="/services"
                                                                className="btn btn-modern btn-primary mt-3"
                                                                style={{
                                                                    backgroundColor: "white",
                                                                    color: "#D21677",
                                                                    fontWeight: "600",
                                                                    border: "none",
                                                                    borderRadius: "30px",
                                                                    padding: "10px 25px",
                                                                }}
                                                            >
                                                                Discover More
                                                            </NavLink>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>


                    <div id="projects" className="container">
                        <div className="row justify-content-center pt-5 mt-5">
                            <div className="col-lg-9 text-center">
                                <h2 className="font-weight-bold mb-2">Projects</h2>
                                {/* <p className="mb-4 d-none">
                                    LOREM IPSUM DOLOR SIT AMET, CONSECTETUR ADIPISCING ELIT
                                </p>
                                <p className="pb-3 mb-4">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce
                                    elementum, nulla vel pellentesque consequat, ante nulla hendrerit
                                    arcu, ac tincidunt mauris lacus sed leo. Vamus suscipit molestie
                                    vestibulum.
                                </p> */}
                            </div>
                        </div>

                       
                        <div className="row pb-5 mb-5">
                            {radiusprojects.map((project) => (
                                <div
                                    key={project.id}
                                    className="col-lg-4 col-md-6 col-sm-12 mb-4"
                                >
                                    <NavLink to={`/project-details/${project.slug}`} 
                                                                            className="portfolio-item"
                                                                            // onClick={() => openProject(project)}
                                                                            style={{ cursor: "pointer" }}
                                                                        >
                                        <span className="thumb-info thumb-info-lighten">
                                            <span className="thumb-info-wrapper">
                                                <img
                                                    src={`https://crmradius.gemsdrive.co.uk/main_image/${project.main_img}`}
                                                    className="img-fluid w-100 border-radius-0"
                                                    alt={project.project_name}
                                                />

                                                <span className="thumb-info-title">
                                                    <span className="thumb-info-inner">
                                                        {project.project_name}
                                                    </span>
                                                    <span className="thumb-info-type">
                                                        {project.service_name}
                                                    </span>
                                                </span>

                                                <span className="thumb-info-action">
                                                    <span className="thumb-info-action-icon bg-dark opacity-8">
                                                        <i className="fas fa-plus"></i>
                                                    </span>
                                                </span>
                                            </span>
                                        </span>
                                    </NavLink>
                                </div>
                            ))}
                        </div>
                        <NavLink to="/projects" className='btn btn-pink'>View More</NavLink>
                    </div>

                    <section className="section section-primary border-top-0 mb-0"
                        style={{
                            background: "linear-gradient(135deg, #D21677 0%, #ff4081 100%)",
                        }}
                    >
                        <div className="container">
                            <div className="row counters counters-sm counters-text-light">

                                <div className="col-sm-6 col-lg-4 mb-5 mb-lg-0">
                                    <div className="counter">
                                        <strong>
                                            <CountUp end={90} duration={3} suffix="+" />
                                        </strong>
                                        <label
                                            className="opacity-8 text-4 mt-1"
                                            style={{ fontWeight: 700 }}
                                        >Clients</label>
                                    </div>
                                </div>

                                <div className="col-sm-6 col-lg-4 mb-5 mb-lg-0">
                                    <div className="counter">
                                        <strong>
                                            <CountUp end={5500} duration={3} suffix="+" />
                                        </strong>
                                        <label
                                            className="opacity-8 text-4 mt-1"
                                            style={{ fontWeight: 700 }}
                                        >Projects</label>
                                    </div>
                                </div>

                                <div className="col-sm-6 col-lg-4 mb-5 mb-sm-0">
                                    <div className="counter">
                                        <strong>
                                            <CountUp end={18} duration={3} />
                                        </strong>
                                        <label
                                            className="opacity-8 text-4 mt-1"
                                            style={{ fontWeight: 700 }}
                                        >
                                            Years
                                        </label>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>
                    <br></br>

                    <section
                        className="section section-height-3 m-0 border-0" id="WhyChooseUs"
                        style={{
                            paddingBottom: "100px",
                            paddingTop: "100px",
                            background: "linear-gradient(135deg, #D21677 0%, #ff4081 100%)",
                        }}
                    >
                        <div className="container">
                            <div className="row align-items-center">
                                {/* ==== Left Side: Glowing Circle with Static Icons ==== */}
                                <div className="col-lg-6 d-flex justify-content-center mb-5 mb-lg-0">
                                    <div className="circle-wrapper position-relative">
                                        <div className="center-circle d-flex align-items-center justify-content-center text-center">
                                            <h5
                                                style={{
                                                    color: "#0d1a4a",
                                                    fontWeight: "900",
                                                    fontSize: "18px",
                                                    lineHeight: "1.0",
                                                    textAlign: "center",
                                                    letterSpacing: "1px",
                                                }}
                                            >
                                                WHY <br /> CHOOSE  <br /> US
                                            </h5>
                                        </div>

                                        {/* Static outer icons */}
                                        <div className="circle-icon icon-top">
                                            <i className="fas fa-briefcase"></i>
                                        </div>
                                        <div className="circle-icon icon-right">
                                            <i className="fas fa-user-tie"></i>
                                        </div>
                                        <div className="circle-icon icon-bottom">
                                            <i className="fas fa-comments"></i>
                                        </div>
                                        <div className="circle-icon icon-left">
                                            <i className="fas fa-flag"></i>
                                        </div>
                                    </div>
                                </div>

                                {/* ==== Right Side: Reasons List ==== */}
                                <div className="col-lg-6 text-center text-lg-start">
                                    <div className="reasons-collapse text-white text-center text-lg-start">


                                        <div className="reasons-list mx-auto" style={{ maxWidth: "600px" }}>
                                            {reasons.map((item, idx) => (
                                                <div key={idx} className="reason-item mb-3">
                                                    <div
                                                        className="reason-header d-flex align-items-center justify-content-between"
                                                        onClick={() => toggleCollapse(idx)}
                                                        style={{
                                                            cursor: "pointer",
                                                            background: "rgba(255,255,255,0.1)",
                                                            padding: "12px 18px",
                                                            borderRadius: "8px",
                                                            transition: "all 0.3s ease",
                                                        }}
                                                    >
                                                        <div className="d-flex align-items-center">
                                                            <div
                                                                className="reason-badge"
                                                                style={{
                                                                    width: "38px",
                                                                    height: "38px",
                                                                    borderRadius: "50%",
                                                                    background: activeIndex === idx ? "#ffffff" : "white",
                                                                    color: activeIndex === idx ? "#D21677" : "#D21677",
                                                                    fontWeight: "700",
                                                                    fontSize: "16px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    marginRight: "12px",
                                                                    boxShadow: activeIndex === idx ? "0 0 15px rgba(255,255,255,0.6)" : "0 0 10px rgba(255,255,255,0.3)",
                                                                    transition: "all 0.3s ease-in-out",
                                                                }}
                                                            >
                                                                {idx + 1}
                                                            </div>
                                                            <span
                                                                className="fw-semibold"
                                                                style={{
                                                                    color: activeIndex === idx ? "#ffffff" : "white",
                                                                    transition: "color 0.3s ease",
                                                                }}
                                                            >
                                                                {item.title}
                                                            </span>
                                                        </div>
                                                        <i
                                                            className={`fas fa-chevron-${activeIndex === idx ? "up" : "down"}`}
                                                            style={{ color: "#fff", transition: "transform 0.3s ease" }}
                                                        ></i>
                                                    </div>

                                                    <div
                                                        className="reason-content"
                                                        style={{
                                                            maxHeight: activeIndex === idx ? "500px" : "0",
                                                            overflow: "hidden",
                                                            transition: "max-height 0.5s ease",
                                                            background: "rgba(255,255,255,0.05)",
                                                            marginTop: activeIndex === idx ? "10px" : "0",
                                                            borderRadius: "8px",
                                                            color: "#ddd",
                                                        }}
                                                    >
                                                        <p
                                                            style={{
                                                                padding: activeIndex === idx ? "12px 18px" : "0 18px",
                                                                color: "#ddd !important",
                                                                margin: 0,
                                                                fontSize: "16px",
                                                                lineHeight: "1.7",
                                                                transition: "all 0.3s ease",
                                                            }}
                                                            className='text-white'
                                                        >
                                                            {item.content}
                                                        </p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        {/* === Inline Styling === */}
                                        <style>{`
                                            .reason-item:hover .reason-badge {
                                                transform: scale(1.1);
                                            }

                                            @keyframes fadeSlideUp {
                                                from { opacity: 0; transform: translateY(20px); }
                                                to { opacity: 1; transform: translateY(0); }
                                            }
                                        `}</style>
                                    </div>
                                    <style>
                                        {`
                                        /* === Animated Number Badge === */
                                        .reason-badge {
                                            width: 40px;
                                            height: 40px;
                                            border-radius: 50%;
                                            background: white;
                                            color: #D21677;
                                            font-weight: 700;
                                            font-size: 16px;
                                            flex-shrink: 0;
                                            display: flex;
                                            align-items: center;
                                            justify-content: center;
                                            margin-right: 15px;
                                            box-shadow: 0 0 10px rgba(255,255,255,0.4);
                                            transition: all 0.3s ease-in-out;
                                        }

                                        /* === Reason Text === */
                                        .reason-text {
                                            color: white;
                                            font-weight: 500;
                                            position: relative;
                                            transition: all 0.3s ease-in-out;
                                        }

                                        /* === Line Glow Animation on Hover === */
                                        .reason-text::after {
                                            content: "";
                                            position: absolute;
                                            left: 0;
                                            bottom: -4px;
                                            width: 0;
                                            height: 2px;
                                            background: white;
                                            transition: width 0.3s ease-in-out;
                                        }

                                        .reason-item:hover .reason-text::after {
                                            width: 100%;
                                        }

                                        /* === Hover Animation === */
                                        .reason-item:hover .reason-badge {
                                            background: #54C8E8;
                                            color: white;
                                            transform: scale(1.1);
                                            box-shadow: 0 0 15px rgba(255,255,255,0.7);
                                        }

                                        .reason-item:hover .reason-text {
                                            color: #54C8E8;
                                            font-weight: 600;
                                            letter-spacing: 0.3px;
                                        }

                                        /* === Fade In Animation === */
                                        .fade-item {
                                            animation: fadeSlideUp 0.8s forwards ease-out;
                                        }
                                        @keyframes fadeSlideUp {
                                            from { opacity: 0; transform: translateY(20px); }
                                            to { opacity: 1; transform: translateY(0); }
                                        }

                                        /* === Responsive Tweaks === */
                                        @media (max-width: 767px) {
                                            .reason-badge {
                                                width: 35px;
                                                height: 35px;
                                                font-size: 14px;
                                            }
                                            .reason-text {
                                                font-size: 15px;
                                            }
                                        }
                                        `}
                                    </style>
                                </div>
                            </div>
                        </div>

                        <style>
                            {`
                                /* Circle Base with Glow */
                                .circle-wrapper {
                                    position: relative;
                                    width: 320px;
                                    height: 320px;
                                    border: 3px solid rgba(255,255,255,0.3);
                                    border-radius: 50%;
                                    box-shadow: 0 0 15px rgba(255,255,255,0.3);
                                    animation: glowPulse 3s infinite ease-in-out;
                                }

                                @keyframes glowPulse {
                                    0% { box-shadow: 0 0 10px rgba(255,255,255,0.3); }
                                    50% { box-shadow: 0 0 25px rgba(255,255,255,0.6); }
                                    100% { box-shadow: 0 0 10px rgba(255,255,255,0.3); }
                                }

                                .center-circle {
                                    width: 180px;
                                    height: 180px;
                                    background: white;
                                    border-radius: 50%;
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    transform: translate(-50%, -50%);
                                    box-shadow: 0 0 15px rgba(0,0,0,0.15);
                                }

                                .circle-icon {
                                    position: absolute;
                                    width: 60px;
                                    height: 60px;
                                    background: white;
                                    color: #d21777;
                                    border-radius: 50%;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    font-size: 22px;
                                    box-shadow: 0 4px 6px rgba(0,0,0,0.2);
                                }

                                .icon-top { top: -30px; left: 50%; transform: translateX(-50%); }
                                .icon-right { top: 50%; right: -30px; transform: translateY(-50%); }
                                .icon-bottom { bottom: -30px; left: 50%; transform: translateX(-50%); }
                                .icon-left { top: 50%; left: -30px; transform: translateY(-50%); }

                                /* Fade-in animation for list items */
                                .fade-item {
                                    animation: fadeSlideUp 0.8s forwards ease-out;
                                }
                                @keyframes fadeSlideUp {
                                    from { opacity: 0; transform: translateY(20px); }
                                    to { opacity: 1; transform: translateY(0); }
                                }

                                /* Responsive */
                                @media (max-width: 767px) {
                                    .circle-wrapper {
                                        width: 240px;
                                        height: 240px;
                                    }
                                    .center-circle {
                                        width: 140px;
                                        height: 140px;
                                    }
                                    .center-circle h5 {
                                        font-size: 20px !important;
                                    }
                                    .circle-icon {
                                        width: 45px;
                                        height: 45px;
                                        font-size: 16px;
                                    }
                                    h2 {
                                        font-size: 1.7rem !important;
                                    }
                                }
                            `}
                        </style>
                    </section>

                    <section id="clients" className="d-none section section-background section-height-4 overlay overlay-show overlay-op-9 border-0 m-0"
                        style={{
                            backgroundImage: "url('img/bg-one-page-1-1.jpg')",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundColor: "#35383d"
                        }}
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col text-center">
                                    <h2 className="font-weight-bold text-color-light mb-2">We’re excited about Porto Template</h2>
                                    <p className="text-color-light opacity-7">30,000 CUSTOMERS IN 100 COUNTRIES USE PORTO TEMPLATE. MEET OUR CUSTOMERS.</p>
                                </div>
                            </div>
                            <div className="row text-center py-3 my-4">
                                <div className="owl-carousel owl-theme carousel-center-active-item carousel-center-active-item-style-2 mb-0" data-plugin-options="{'responsive': {'0': {'items': 1}, '476': {'items': 1}, '768': {'items': 5}, '992': {'items': 7}, '1200': {'items': 7}}, 'autoplay': true, 'autoplayTimeout': 3000, 'dots': false}">
                                    <div>
                                        <img className="img-fluid" src="img/logos/logo-light-1.png" alt="" />
                                    </div>
                                    <div>
                                        <img className="img-fluid" src="img/logos/logo-light-2.png" alt="" />
                                    </div>
                                    <div>
                                        <img className="img-fluid" src="img/logos/logo-light-3.png" alt="" />
                                    </div>
                                    <div>
                                        <img className="img-fluid" src="img/logos/logo-light-4.png" alt="" />
                                    </div>
                                    <div>
                                        <img className="img-fluid" src="img/logos/logo-light-5.png" alt="" />
                                    </div>
                                    <div>
                                        <img className="img-fluid" src="img/logos/logo-light-6.png" alt="" />
                                    </div>
                                    <div>
                                        <img className="img-fluid" src="img/logos/logo-light-4.png" alt="" />
                                    </div>
                                    <div>
                                        <img className="img-fluid" src="img/logos/logo-light-2.png" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">

                                    <div className="owl-carousel owl-theme nav-bottom rounded-nav mb-0" data-plugin-options="{'items': 1, 'loop': true, 'autoHeight': true}">
                                        <div>
                                            <div className="testimonial testimonial-style-2 testimonial-light testimonial-with-quotes testimonial-quotes-primary mb-0">
                                                <blockquote>
                                                    <p className="text-5 line-height-5 mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed eget risus porta, tincidunt turpis at, interdum tortor. Suspendisse potenti.</p>
                                                </blockquote>
                                                <div className="testimonial-author">
                                                    <p><strong className="font-weight-extra-bold text-2">- John Smith. Okler</strong></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="testimonial testimonial-style-2 testimonial-light testimonial-with-quotes testimonial-quotes-primary mb-0">
                                                <blockquote>
                                                    <p className="text-5 line-height-5 mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed eget risus porta, tincidunt turpis at, interdum tortor. Suspendisse potenti.</p>
                                                </blockquote>
                                                <div className="testimonial-author">
                                                    <p><strong className="font-weight-extra-bold text-2">- John Smith. Okler</strong></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>

                    <div id="team" className="container pb-4 d-none">
                        <div className="row pt-5 mt-5 mb-4">
                            <div className="col text-center" >
                                <h2 className="font-weight-bold mb-1">Team</h2>
                                <p>LOREM IPSUM DOLOR SIT AMET, CONSECTETUR ADIPISCING ELIT</p>
                            </div>
                        </div>
                        <div className="row pb-5 mb-5"  >
                            <div className="col-sm-6 col-lg-3 mb-4 mb-lg-0">
                                <span className="thumb-info thumb-info-hide-wrapper-bg thumb-info-no-zoom">
                                    <span className="thumb-info-wrapper">
                                        <a href="about-me.html">
                                            <img src="img/team/team-1.jpg" className="img-fluid" alt="" />
                                        </a>
                                    </span>
                                    <span className="thumb-info-caption">
                                        <h3 className="font-weight-extra-bold text-color-dark text-4 line-height-1 mt-3 mb-0">John Doe</h3>
                                        <span className="text-2 mb-0">CEO</span>
                                        <span className="thumb-info-caption-text pt-1">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras ac ligula mi, non suscipitaccumsan</span>
                                        <span className="thumb-info-social-icons">
                                            <a target="_blank" href="http://www.facebook.com"><i className="fab fa-facebook-f"></i><span>Facebook</span></a>
                                            <a href="http://www.twitter.com"><i className="fab fa-x-twitter"></i><span>Twitter</span></a>
                                            <a href="http://www.linkedin.com"><i className="fab fa-linkedin-in"></i><span>Linkedin</span></a>
                                        </span>
                                    </span>
                                </span>
                            </div>
                            <div className="col-sm-6 col-lg-3 mb-4 mb-lg-0">
                                <span className="thumb-info thumb-info-hide-wrapper-bg thumb-info-no-zoom">
                                    <span className="thumb-info-wrapper">
                                        <a href="about-me.html">
                                            <img src="img/team/team-2.jpg" className="img-fluid" alt="" />
                                        </a>
                                    </span>
                                    <span className="thumb-info-caption">
                                        <h3 className="font-weight-extra-bold text-color-dark text-4 line-height-1 mt-3 mb-0">Jessica Doe</h3>
                                        <span className="text-2 mb-0">DESIGNER</span>
                                        <span className="thumb-info-caption-text pt-1">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras ac ligula mi, non suscipitaccumsan</span>
                                        <span className="thumb-info-social-icons">
                                            <a target="_blank" href="http://www.facebook.com"><i className="fab fa-facebook-f"></i><span>Facebook</span></a>
                                            <a href="http://www.twitter.com"><i className="fab fa-x-twitter"></i><span>Twitter</span></a>
                                            <a href="http://www.linkedin.com"><i className="fab fa-linkedin-in"></i><span>Linkedin</span></a>
                                        </span>
                                    </span>
                                </span>
                            </div>
                            <div className="col-sm-6 col-lg-3 mb-4 mb-sm-0">
                                <span className="thumb-info thumb-info-hide-wrapper-bg thumb-info-no-zoom">
                                    <span className="thumb-info-wrapper">
                                        <a href="about-me.html">
                                            <img src="img/team/team-3.jpg" className="img-fluid" alt="" />
                                        </a>
                                    </span>
                                    <span className="thumb-info-caption">
                                        <h3 className="font-weight-extra-bold text-color-dark text-4 line-height-1 mt-3 mb-0">Ricki Doe</h3>
                                        <span className="text-2 mb-0">DEVELOPER</span>
                                        <span className="thumb-info-caption-text pt-1">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras ac ligula mi, non suscipitaccumsan</span>
                                        <span className="thumb-info-social-icons">
                                            <a target="_blank" href="http://www.facebook.com"><i className="fab fa-facebook-f"></i><span>Facebook</span></a>
                                            <a href="http://www.twitter.com"><i className="fab fa-x-twitter"></i><span>Twitter</span></a>
                                            <a href="http://www.linkedin.com"><i className="fab fa-linkedin-in"></i><span>Linkedin</span></a>
                                        </span>
                                    </span>
                                </span>
                            </div>
                            <div className="col-sm-6 col-lg-3">
                                <span className="thumb-info thumb-info-hide-wrapper-bg thumb-info-no-zoom">
                                    <span className="thumb-info-wrapper">
                                        <a href="about-me.html">
                                            <img src="img/team/team-4.jpg" className="img-fluid" alt="" />
                                        </a>
                                    </span>
                                    <span className="thumb-info-caption">
                                        <h3 className="font-weight-extra-bold text-color-dark text-4 line-height-1 mt-3 mb-0">Melinda Doe</h3>
                                        <span className="text-2 mb-0">SEO ANALYST</span>
                                        <span className="thumb-info-caption-text pt-1">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras ac ligula mi, non suscipitaccumsan</span>
                                        <span className="thumb-info-social-icons">
                                            <a target="_blank" href="http://www.facebook.com"><i className="fab fa-facebook-f"></i><span>Facebook</span></a>
                                            <a href="http://www.twitter.com"><i className="fab fa-x-twitter"></i><span>Twitter</span></a>
                                            <a href="http://www.linkedin.com"><i className="fab fa-linkedin-in"></i><span>Linkedin</span></a>
                                        </span>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>

                    <section id="contact" className="section bg-color-grey border-0 py-0 m-0">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-6">
                                    <div id="googlemaps" className="google-map h-100 m-0" style={{ minHeight: '400px' }}>
                                        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3612.192292463675!2d55.241615!3d25.129189!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5d0c13832339%3A0x60b65104a1ad12f8!2sRadius%20Exhibition%20Fixtures%20Works%20LLC!5e0!3m2!1sen!2sae!4v1762586190469!5m2!1sen!2sae" style={{ border: '0', width: '100%', height: '100%' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                    </div>
                                </div>
                                <div className="col-md-6 p-5 my-5">

                                    <div className="px-4">
                                        <h2 className="font-weight-bold line-height-1 mb-2">Contact Us</h2>
                                        <form className="contact-form form-style-2 pe-xl-5" action="php/contact-form.php" method="POST">
                                            <div className="contact-form-success alert alert-success d-none mt-4">
                                                <strong>Success!</strong> Your message has been sent to us.
                                            </div>

                                            <div className="contact-form-error alert alert-danger d-none mt-4">
                                                <strong>Error!</strong> There was an error sending your message.
                                                <span className="mail-error-message text-1 d-block"></span>
                                            </div>

                                            <div className="row">
                                                <div className="form-group col-xl-4">
                                                    <input type="text" value="" data-msg-required="Please enter your name." maxlength="100" className="form-control" name="name" placeholder="Name" required />
                                                </div>
                                                <div className="form-group col-xl-8">
                                                    <input type="email" value="" data-msg-required="Please enter your email address." data-msg-email="Please enter a valid email address." maxlength="100" className="form-control" name="email" placeholder="Email" required />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form-group col">
                                                    <input type="text" value="" data-msg-required="Please enter the subject." maxlength="100" className="form-control" name="subject" placeholder="Subject" required />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form-group col">
                                                    <textarea maxlength="5000" data-msg-required="Please enter your message." rows="4" className="form-control" name="message" placeholder="Message" required></textarea>
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <ReCAPTCHA
                                                    sitekey="6LdZTQYsAAAAALnDtV-qcDoJjxavHLBW6Eb-yEkv"
                                                    onChange={handleCaptchaChange}
                                                />
                                            </div>

                                            <div className="row">
                                                <div className="form-group col">
                                                    <input type="submit" value="SUBMIT" className="btn btn-primary btn-rounded font-weight-semibold px-5 btn-py-2 text-2" data-loading-text="Loading..." />
                                                </div>
                                            </div>
                                        </form>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>

                </div>


                <div role="main" className="main">
                    <Footer />
                </div>

            </div>
            {/* === MODAL === */}
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="xl"
                centered
            >
                {activeProject && (
                    <div className="ajax-container p-4">
                        <div className="row align-items-center py-3">
                            <div className="col text-start">
                                
                            </div>
                            <div className="col text-center">
                                <h2 className="text-dark fw-bold mb-0">{activeProject.title}</h2>
                            </div>
                            <div className="col text-end">
                                
                            </div>
                        </div>

                        <div className="row pb-4 mb-2">
                            <div className="col-sm-6">

                                
                                <OwlCarousel
                                    className="owl-carousel owl-theme mb-0"
                                    loop
                                    margin={10}
                                    items={1}
                                    autoplay
                                    autoplayTimeout={4000}
                                    autoplayHoverPause
                                    nav={false}
                                    
                                >
                                    {activeProject.multiple_img?.map((image, index) => (
                                        <a key={index} href={image} target='_blank' className="item">
                                            <img
                                                src={image}
                                                className="img-fluid border-radius-0"
                                                alt={`Slide ${index}`}
                                            />
                                        </a>
                                    ))}
                                </OwlCarousel>

                                <strong className="text-uppercase text-dark">Share</strong>
                                <ul className="social-icons list-inline mt-2">
                                    <li className="list-inline-item">
                                        <a href="http://facebook.com" target="_blank" rel="noreferrer">
                                            <i className="fab fa-facebook-f"></i>
                                        </a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a href="http://x.com" target="_blank" rel="noreferrer">
                                            <i className="fab fa-x-twitter"></i>
                                        </a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a href="http://linkedin.com" target="_blank" rel="noreferrer">
                                            <i className="fab fa-linkedin-in"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div className="col-sm-6">
                                <h4 className="text-dark fw-normal mb-2">
                                    Project <strong className="fw-bold">Description</strong>
                                </h4>
                                <p>{activeProject.details}</p>

                                <h4 className="text-dark fw-normal mt-4 mb-2">
                                    Project <strong className="fw-bold">Details</strong>
                                </h4>
                                <div dangerouslySetInnerHTML={{ __html: activeProject.description }} />
                                {/* <ul className="list-unstyled">
                                    <li>
                                        <strong>Date:</strong> {activeProject.date}
                                    </li>
                                     
                                    <li>
                                        <strong>Project URL:</strong>{" "}
                                        <a
                                            href={activeProject.projectUrl}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {activeProject.projectUrl}
                                        </a>
                                    </li>
                                </ul> */}
                            </div>
                        </div>

                        <div className="text-center mt-3">
                            <Button variant="secondary" onClick={() => setShowModal(false)}>
                                Close
                            </Button>
                        </div>
                    </div>
                )}
            </Modal>
        </div>
        </>

    );
}

export default Index;
